module.exports = __webpack_public_path__ + "static/img/iphone_ldttitle5.f4db6c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldttitle5.png
// module id = 1hFO
// module chunks = 0